import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-license-page",
  templateUrl: "./LicensePage.html"
})
export class LicensePage {

  private readonly _swissNumberFormatter = new Intl.NumberFormat("de-CH");

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get organization() {
    return this.appController.organization;
  }

  public get availableLicenseTypes() {
    return this.appController.availableLicenseTypes;
  }

  public formatPrice(licensePrice: number): string {
    return this._swissNumberFormatter.format(licensePrice);
  }

  public get newLicenseTypeName(): string {
    return this.organization.newLicenseTypeName;
  }

  public set newLicenseTypeName(newLicenseTypeName: string) {
    this.organization.setNewLicenseType(this.availableLicenseTypes.find(licenseType => licenseType.name === newLicenseTypeName));
  }

}
